













































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { Member } from '@/types/Member.type'
import store from '@/store/store'

const user = namespace('user')

@Component
export default class CGV extends Vue {
    @Prop() private msg!: string
    @user.Getter isConnected!: boolean
    @user.Getter isCommunity!: boolean
    @user.Getter isLead!: boolean
    @user.State me!: Member

    routing: any = window.Routing

    @Watch('me')
    openModal() {
        if (
            this.me &&
            this.isConnected &&
            !this.isCommunity &&
            !this.isLead &&
            !this.me.cgv_accepted_at &&
            !window.location.pathname.startsWith('/update-account') &&
            !window.location.pathname.startsWith('/login') &&
            !window.location.pathname.startsWith('/register') &&
            !window.location.pathname.startsWith('/logout') &&
            // Same role check as in security.yml : /accept-cgv
            (store.getters['user/hasRole']('ROLE_BL_LECLUB') ||
                store.getters['user/hasRole']('ROLE_BL_LECLUB_PARTNER_CONTACT'))
        ) {
            window.$('#cgv').modal('show')
            const date = new Date()
            date.setTime(date.getTime() + 24 * 60 * 60 * 1000)

            // document.cookie = 'cgv_modal_seen=1; path=/; expires=' + date.toGMTString() + ';'
        }
    }
}
